import React from 'react';
import cn from 'classname';

const Row = (props) => {
	const { row, intervals, can, periodSwitch, isHiddenProfit } = props;
	const dates = intervals || [];
	const datesNumber = dates.length || null;
	return (
		<tr className="top-affiliate-individual-expanded-row">
			<td className="fixed-col hover-pointer first-affiliate-col">
				{row.offer_geo}<span className="opacity-0">{'š'}</span>
			</td>
			<td/>
			<td/>
			<td
				className={cn({'top-affiliates-table-cell_description': true, 'no-copy-col': true, 'forecast-cell': true})}
			>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{Math.round((row[`total_all_statuses`] || 0) / datesNumber)}
					</span>|
					<span className="width-50-p padding-0-5 text-left light-green-text">
						{Math.round((row[`total_approved`] || 0) / datesNumber)}
					</span>
				</p>
				<p className="flex-center forecast-cell">
					<span className="width-50-p padding-0-5 text-right">
						{Math.round(row[`total_all_statuses_approve_percent`] || 0)}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{Math.round(row[`total_valid_approve_percent`] || 0)}%
					</span>
				</p>
				{ can('viewAll') && !isHiddenProfit && <p className="flex-center">
					Profit {Math.round((row[`total_profit_usd`] || 0) / datesNumber)}$
				</p>}
			</td>
			{
				dates.map((item, key, arr) =>
					<ConversionsDateCell {...props} key={key} item={item} index={key} arr={arr} periodSwitch={periodSwitch} />
				)
			}
			<td className={cn({
				'top-affiliates-table-cell_description': true, 'no-copy-col': true
			})}>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{row[`total_all_statuses`] || 0}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{row[`total_approved`] || 0}
					</span>
				</p>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{row[`total_all_statuses_approve_percent`] || 0}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{row[`total_valid_approve_percent`] || 0}%
					</span>
				</p>
				{
					can('viewAll') && !isHiddenProfit &&
						<p className="flex-center">Profit {Math.round(row[`total_profit_usd`]) || 0}</p>
				}
			</td>
		</tr>
	);
};

const ConversionsDateCell = props => {
	const { item, arr, can, row, index, isHiddenProfit} = props;

	const isMoreThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) > Number(row[`${arr[index + 1]}_all_statuses`]);

	const isLessThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) < Number(row[`${arr[index + 1]}_all_statuses`]);

	return <td
		className={cn({
			'top-affiliates-table-cell_description': true,
			'no-copy-col': true
		})}
	>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses`] || 0} `}
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_approved`] || 0}`}
				<span className={cn({ 'less': isLessThenBefore, 'more': isMoreThenBefore })}></span>
			</span>
		</p>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses_approve_percent`] || 0} `}%
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_valid_approve_percent`] || 0}`}%
			</span>
		</p>
		{
			can('viewAll') && !isHiddenProfit &&
				<p className="text-center">Profit {Math.round(row[`${item}_profit_usd`]) || 0}$</p>
		}
	</td>;
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/components/table/expander-row.js